import { useEffect, useState } from 'react';

function NutritionalFactsTableView({ nutritionalFactsData }) {
  const [nutritionalFactsTable, setNutritionalFactsTable] = useState([]);

  useEffect(() => {
    if (!nutritionalFactsData) {
      setNutritionalFactsTable([]);
      return;
    }

    try {
      if (Array.isArray(nutritionalFactsData)) {
        setNutritionalFactsTable(nutritionalFactsData);
        return;
      }

      const parsed = JSON.parse(nutritionalFactsData);
      setNutritionalFactsTable(parsed);
    } catch (error) {
      console.error("Erro ao parsear tabela nutricional:", error);
      setNutritionalFactsTable([]);
    }
  }, [nutritionalFactsData]);

  if (!nutritionalFactsTable.length) {
    return <p className="text-sm text-gray-400">Sem informações nutricionais</p>;
  }

  return (
    <table className="table-auto w-full shadow-md rounded-lg text-xs text-center break-words">
      <thead>
        <tr className="bg-custom_blue text-white h-10 font-montserrat">
          <th className="p-2">Nutriente</th>
          <th className="p-2">Quantidade por porção</th>
          <th className="p-2">%VD</th>
        </tr>
      </thead>
      <tbody>
        {nutritionalFactsTable.map((row, index) => (
          <tr
            key={index}
            className="leading-relaxed border-b-2 border-slate-200"
          >
            <td className="text-left px-2">{row.nutrient}</td>
            <td>{row.valueInPortion}</td>
            <td>{row.dailyValue}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default NutritionalFactsTableView;
